import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'seconds'
})
export class SecondsPipe implements PipeTransform {

  transform(time: any): any {
    const minutes = Math.round((+time - 30) / 60 % 60).toString().padStart(2, '0');
    const seconds = (+time % 60).toString().padStart(2, '0');;
    return `${minutes} 分 ${seconds} 秒`;
  }

}
